import React from 'react';
import { CheckCircle2Icon, XCircleIcon } from 'lucide-react';
export function PlanSection() {
  return <section className="py-20 bg-[#0d1529]" data-id="element-160">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-161">
        <div className="text-center mb-16" data-id="element-162">
          <span className="text-[#00d4ff] font-semibold tracking-widest uppercase text-sm" data-id="element-163">
            El Protocolo
          </span>
          <h2 className="font-heading text-4xl md:text-6xl font-bold text-white mt-2 mb-6 uppercase" data-id="element-164">
            Plan B: <span className="text-[#00d4ff]" data-id="element-165">Cuerpo 4.0</span>
          </h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-166">
            El último protocolo que necesitarás para volver a usar tu ropa
            favorita. Diseñado específicamente para el metabolismo de 40+.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-10 items-start mb-16" data-id="element-167">
          {/* What you WON'T do */}
          <div className="bg-[#111827] p-8 rounded-2xl border border-red-500/20" data-id="element-168">
            <h3 className="font-heading text-2xl font-bold text-white mb-6 uppercase" data-id="element-169">
              Lo que NO harás:
            </h3>
            <ul className="space-y-4" data-id="element-170">
              {['Contar calorías obsesivamente', 'Comer comida de "conejo" insípida', 'Pasar 2 horas en el gimnasio', 'Comprar suplementos caros e inútiles'].map(item => <li key={item} className="flex items-center text-slate-300" data-id="element-171">
                  <XCircleIcon className="w-6 h-6 text-red-400 mr-3 shrink-0" data-id="element-172" />
                  <span data-id="element-173">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* What you GET */}
          <div className="bg-[#111827] p-8 rounded-2xl border border-[#00d4ff]/30" data-id="element-174">
            <h3 className="font-heading text-2xl font-bold text-white mb-6 uppercase" data-id="element-175">
              Lo que SÍ obtienes:
            </h3>
            <ul className="space-y-5" data-id="element-176">
              {[{
              title: 'Checklist de 7 Días',
              desc: 'Paso a paso exacto para reiniciar tu sistema.'
            }, {
              title: 'Protocolo de Cenas Sociales',
              desc: 'Come fuera sin inflamar tu cintura ni ser el "raro" de la mesa.'
            }, {
              title: 'Movimiento Inteligente',
              desc: '15 minutos, 3 veces por semana. Eso es todo.'
            }, {
              title: 'El "Apagón de Estrés"',
              desc: 'Técnicas simples para bajar el cortisol en 5 minutos.'
            }, {
              title: 'Guía de Suplementación 40+',
              desc: 'Solo lo que realmente funciona, sin gastar de más.'
            }].map(item => <li key={item.title} className="flex items-start" data-id="element-177">
                  <CheckCircle2Icon className="w-6 h-6 text-[#00d4ff] mr-3 mt-0.5 shrink-0" data-id="element-178" />
                  <div data-id="element-179">
                    <span className="font-bold text-white block" data-id="element-180">
                      {item.title}
                    </span>
                    <span className="text-slate-400 text-sm" data-id="element-181">{item.desc}</span>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}